import { fork, actionChannel, put, take, call } from 'redux-saga/effects';
import * as adminActions from './action';
//import * as catActions from '../../Dashboard/action'
const settings = require('../../../settings');



/**
 * Saga watchers
 */
export function* watchGetSupergroupTemplatesections() {
    let payload;
    const reqChannel = yield actionChannel(adminActions.GET_TEMPLATESECTIONSFORSUPERGROUP_REQUEST)
    while (payload = yield take(reqChannel)) {

        yield fork(getSectionsList, payload);
    }
}

export function* watchSetSupergroupTemplatesections() {
    let payload;
    const reqChannel = yield actionChannel(adminActions.SET_TEMPLATESECTIONSFORSUPERGROUP_REQUEST)
    while (payload = yield take(reqChannel)) {

        yield fork(setSectionsList, payload);
    }
}

const getSectionsFromjoobster = (payload) => {


    console.log('this is the category payload object: ', payload)
    return fetch(settings.api_base_path + settings.api_admin_path + "/supergroup/" + payload.sgid + "/templatesection", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + payload.authToken
        },

    }).then((res) => res.json())
        .then((data) => data);


}




function* getSectionsList(action) {
    try {
        const result = yield call(getSectionsFromjoobster, action.payload)
        console.log('getSectionsList: ', result)

        if (result.status == "ok") {
            yield put({ type: adminActions.GET_TEMPLATESECTIONSFORSUPERGROUP_SUCCESS, payload: result.templateSections });
        } else {
            yield put({ type: adminActions.GET_TEMPLATESECTIONSFORSUPERGROUP_ERROR, payload: {}, error: true });
        }

    } catch (error) {
        yield put({ type: adminActions.GET_TEMPLATESECTIONSFORSUPERGROUP_ERROR, payload: error, error: true });
    }
}



const setSectionsTojoobster = (payload) => {

    return fetch(settings.api_base_path + settings.api_admin_path + "/supergroup/" + payload.sgid + "/templatesection", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + payload.authToken
        },
        body: JSON.stringify(payload.body.map(e => e.name)),
    }).then((res) => res.json() )
        .then((data) => data
        );


}




function* setSectionsList(action) {
    console.log('action in saga: ', action)
    try {
        const result = yield call(setSectionsTojoobster, action.payload)

        if (result.status == "ok") {


            console.log('set is: ', result.templateSections)
            yield put({ type: adminActions.SET_TEMPLATESECTIONSFORSUPERGROUP_SUCCESS, payload: result.templateSections });
//            yield put({ type: catActions.UPDATE_CATEGORIES, payload: {categories: result.categories} });

        } else {
            yield put({ type: adminActions.SET_TEMPLATESECTIONSFORSUPERGROUP_ERROR, payload: {}, error: true });
        }

    } catch (error) {
        yield put({ type: adminActions.SET_TEMPLATESECTIONSFORSUPERGROUP_ERROR, payload: error, error: true });
    }
}


